import { inject, Injectable } from '@angular/core';
import { Option } from '@sapphire/result';

import { ToastService } from '@ps/core-overlay';
import { UserSettingsSelectorsFacade } from '@ps/user-settings-data-access';
import { Survey } from '@ps/survey-utils';
import { Nullable } from '@ps/utils';

import { SurveyCreationSelectorsFacade } from '../../state/survey-creation.selectors.facade';
import {
  buildChildSwitchContext,
  ChildSwitchViolation,
  validateLocaleAdd,
} from '../../state/core/validation/child-switch';

@Injectable({ providedIn: 'root' })
export class ChildSwitchGuardService {
  private readonly _toastService = inject(ToastService);
  private readonly _userSettingsSelectors = inject(UserSettingsSelectorsFacade);
  private readonly _selectors = inject(SurveyCreationSelectorsFacade);

  public allowsAdd(survey: Nullable<Survey>): boolean {
    const buyerSettings = this._userSettingsSelectors.buyerSettings();

    return validateLocaleAdd(
      Option.from(survey),
      buildChildSwitchContext({
        advancedFilters: this._selectors.advancedFilters(),
        isRespondentStatusFilterEnabled:
          !!buyerSettings.enableRespondentStatusFilter,
        isManualProcessingEnabled: !!buyerSettings.enableManualProcessing,
        isFeasibilityLoading: this._selectors.feasibilityLoading(),
        uniqueLinks: this._selectors.launchForm().value.uniqueLinks,
        hasFeotQuotaViolation: false,
      }),
    ).match({
      ok: () => true,
      err: (violation) => {
        this._notify(violation);
        return false;
      },
    });
  }

  private _notify({ message, severity }: ChildSwitchViolation): void {
    if (severity === 'warning') {
      this._toastService.warning(message);
      return;
    }

    this._toastService.error(message);
  }
}
